import { Component, OnInit, ViewChild,  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { PowerofattorneyService } from 'src/app/services/powerofattorney.service';
import { AlertComponent } from '../../alert/alert.component';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
declare var $: any;
@Component({
  selector: 'app-powerofattorneylist',
  templateUrl: './powerofattorneylist.component.html',
  styleUrls: ['./powerofattorneylist.component.css']
})
export class PowerofattorneylistComponent implements OnInit {
  isSearchDivVisible = false;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptionsOfPoa: DataTables.Settings = {};
  dtTriggerPoa: Subject<any> = new Subject();
  editPoaId: any;
  token: any = localStorage.getItem('token')

  constructor(private PowerofattorneyService: PowerofattorneyService, private alert: AlertComponent, 
    private router: Router,private activatedRoute: ActivatedRoute) { }

  poaList: any;
  deletePoaId: any;
  public downloadAllLink: string = "documentManagement/downloadSingleFileOnID/";
  dateOfPOA : any;
  dateOfMeeting: any;
  nameOfPerson: any;
  futureToDate: NgbDateStruct;
  futureToDateTo: NgbDateStruct;

  ngOnInit() {
    this.dtOptionsOfPoa = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Power of Attorney',
          title: 'Power of Attorney',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 4],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
    this.getPoaData();
  }

  getPoaData() {
    this.PowerofattorneyService.getPoaData({ "isSearch": false }).subscribe(response => {
      if (response.status == 0) {
        this.poaList = response.data;
        this.adjustdirectormasterTable();
      }
    })
  }

  adjustdirectormasterTable() {
    setTimeout(() => {
      this.dtTriggerPoa.next();
      // $("#powerofattorneylistTable").DataTable().columns.adjust().draw();
    }, 200);
  }

  downloadFile(docId) {
    window.location.href = environment.pssServerUrl + this.downloadAllLink + docId+ '/' + this.token;
  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['powerofattorney', 'add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
   
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getPoaOnEdit(id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['powerofattorney', 'edit',id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['powerofattorney/edit/' + id])
  }

  generateOutput() {
    this.editPoaId = null;
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfPOA,
      toDate: this.dateOfMeeting,
      name: this.nameOfPerson
    }
    this.PowerofattorneyService.generatePoaDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.PowerofattorneyService.downloadPoaFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.PowerofattorneyService.downloadPoaPdfFile(id, 'Multi');
  }

  confirmDelete(id) {
    this.deletePoaId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletePoa() {
    var self = this;
    this.PowerofattorneyService.deletePoaData(this.deletePoaId).subscribe(response => {
      if (response.status == 0) {
        self.alert.success(response.message);
        $("#powerofattorneylistTable").DataTable().destroy();
        $('#deleteConfirm').modal('toggle');
      } else {
        self.alert.error(response.message);
      }
      this.getPoaData();

    })

  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch() {
    var searchParam =
    {
      "nameOfPerson": this.nameOfPerson,
      "dateOfPOA": this.setDate(this.dateOfPOA),
      "dateOfMeeting": this.setDate(this.dateOfMeeting),
      'isSearch': true,
    };

    this.poaList = [];
    $("#powerofattorneylistTable").DataTable().destroy();
    this.PowerofattorneyService.getPoaData(searchParam).subscribe(registerList => {
      this.poaList = registerList.data;
      this.dtTriggerPoa.next();
    });
  }
  clearAdvSearch() {
    this.nameOfPerson = '';
    this.dateOfPOA = undefined;
    this.dateOfMeeting = undefined;
    $("#powerofattorneylistTable").DataTable().destroy();
    this.getPoaData();

    // this.response = true;

    //   localStorage.setItem('searchInvestmentsflag', 'false');
  }
}

